import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DepartmentService } from '../../services/jrni/department.service';
import { AlertService } from '../../_alert';
import { NgxSpinnerService } from 'ngx-spinner';
import { BasketService } from '../../services/jrni/basket.service';
import { TranslateService } from '@ngx-translate/core';
import { DatastoreService } from '../../services/datastore.service';
import { ServicesService } from '../../services/jrni/services.service';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { CapitaService } from '../../services/capita.service';
import { ApiService } from '../../services/jrni/api.service';

@Component({
	selector: 'app-confirmation',
	templateUrl: './confirmation.component.html',
	styleUrls: ['./confirmation.component.scss'],
})
export class ConfirmationComponent implements OnInit {
	selectedDepartment;
	pageTitle: string;
	confirmationPageText: string;
	purchase;
	bookings;
	selectedService;
	selectedLocation;
	address;
	selectedDate;
	selectedSlot;
	client;
	endSlot;
	total;
	extraDetailsPresent;
	bookingSummaryData = [];
	bookingsPlaceholder;
	selectedResource;
	selectedResourceObj: any;
	confirmPayment: boolean = false;
	adminMode: boolean = false;

	hideCongratsMessageForService = [112721, 112781, 112801, 112791, 112811];

	constructor(
		private router: Router,
		private departmentService: DepartmentService,
		private alertService: AlertService,
		private spinner: NgxSpinnerService,
		private basketService: BasketService,
		public translateService: TranslateService,
		private servicesService: ServicesService,
		public datastoreService: DatastoreService,
		private availabilityService: AvailabilityService,
		private capitaService: CapitaService,
		private apiService: ApiService
	) {}

	restartJourney() {
		this.router.navigate(['/services']);
	}

	goToLogin() {
		window.location.href =
			'https://myceremony.staging.bookinglab.co.uk/essex-staging/52500/access';
	}

	ngOnInit() {
		this.scrollToTop();
		this.spinner.show();
		// Use this.departmentService.getLocation() if the services are set on the children departments
		// Use this.departmentService.get() if the services are set on the parent department
		this.departmentService.getLocation().then(async (selectedDepartment) => {
			if (selectedDepartment === undefined) {
				this.restartJourney();
			} else {
				this.client = {
					first_name: this.datastoreService.booking.first_name,
					last_name: this.datastoreService.booking.last_name,
					email: this.datastoreService.booking.email,
				};
				this.selectedDepartment = await selectedDepartment.$getParent();
				// Get the configurable data
				if (this.selectedDepartment.hasOwnProperty('extra')) {
					// Set the title on the login page to the title from the business question
					this.selectedDepartment.extra.hasOwnProperty(
						'confirmation_page_title'
					)
						? (this.pageTitle =
								this.selectedDepartment.extra.confirmation_page_title)
						: (this.pageTitle = 'Confirmation title not set');
					// Set the extra text on the page to the text taken from the business question
					this.selectedDepartment.extra.hasOwnProperty('confirmation_page_text')
						? (this.confirmationPageText =
								this.selectedDepartment.extra.confirmation_page_text)
						: null;
				}

				// Get the selected service
				this.servicesService.get().then((service) => {
					console.log(service);
					this.selectedService = service;
					this.selectedService.calculated_duration =
						Number(this.datastoreService.extraDuration) +
						Number(this.selectedService.durations[0]);

					if (this.selectedService.extra?.online_payment == 'Yes') {
						this.confirmPayment = true;
					}
					if (this.datastoreService.adminJourney) {
						this.confirmPayment = false;
						this.adminMode = true;
					}

					this.datastoreService.bookingQuestions.forEach((question) => {
						if (this.datastoreService.bookingForm.value[question['id']]) {
							this.bookingSummaryData.push({
								name: question.name,
								answer: this.datastoreService.bookingForm.value[question.id],
								detail_type: question.detail_type,
								price: question.price,
							});
						}
					});
					// Check if the questions contain any other purchase details
					const extraDetails = this.bookingSummaryData.filter(
						(elem) => elem.detail_type !== 'check-price'
					);
					extraDetails.length > 0
						? (this.extraDetailsPresent = true)
						: (this.extraDetailsPresent = false);
					// Calculate purchase total
					const paidItems = this.bookingSummaryData.filter(
						(item) => item.detail_type === 'check-price'
					);
					this.total =
						paidItems.map((items) => items.price).reduce((a, b) => a + b, 0) +
						this.selectedService?.price;
				});

				// Get the selected slot
				if (this.datastoreService.selectedSlot) {
					this.availabilityService.getSelectedSlot().then((slot) => {
						this.selectedSlot = slot;
						console.log(slot);
						this.availabilityService.getEndSlot().then((slot) => {
							this.endSlot = slot;
						});
					});
				}
				// this.selectedSlot = this.datastoreService.selectedSlot;
				// Get the selected location
				// Use this.departmentService.getLocation() if the services are set on the children departments
				// Use this.departmentService.get() if the services are set on the parent department
				this.departmentService.getLocation().then((location) => {
					this.selectedLocation = location;
					location?.$getAddress().then((res) => {
						this.address = res;
					});
				});
				// Get the purchase
				this.basketService.getPurchase().then(
					async (purchase) => {
						this.purchase = purchase;
						// if (!purchase && this.datastoreService.booking) {
						this.bookingsPlaceholder = {
							referenceNo: this.datastoreService.booking.id,
						};
						// comented out 21/11/24 because the HAL client checkout changed and purchase no longer has a $get function
						// } else {
						//   purchase.$get('bookings').then(bookings => {
						//     this.bookings = bookings[0];
						//     this.bookingsPlaceholder = {
						//       referenceNo: this.bookings.id
						//     };
						//   });
						// }
						try {
							// await this.apiService.sendEmail('CONFIRMED', this.datastoreService.booking, this.datastoreService.booking.email, this.selectedDepartment);
							await this.apiService.resendConfirmation(
								this.selectedLocation,
								this.datastoreService.booking.id
							);
						} catch (err) {
							console.error(err);
						}
						// if (this.confirmPayment) {
						//   // confirm booking
						//   await this.capitaService.confirm(this.datastoreService.booking.purchase_id, this.selectedLocation.id, this.datastoreService.purchase.total_price);
						// }
						const booking = JSON.parse(localStorage.getItem('booking'));
						this.selectedResourceObj = JSON.parse(
							localStorage.getItem('resource')
						);
						this.selectedSlot = JSON.parse(localStorage.getItem('date'));
						this.selectedLocation = JSON.parse(
							localStorage.getItem('location')
						);
						this.selectedService = JSON.parse(localStorage.getItem('service'));
						localStorage.removeItem('auth_token');
						this.spinner.hide();
					},
					(err) => {
						this.alertService.error(
							this.translateService.instant('COMMON.GENERAL_ERR')
						);
						this.spinner.hide();
					}
				);
			}
		});

		if (this.datastoreService.adminJourney) {
			console.log('Admin journey. Use v1');
			this.basketService.reassignCompany(this.datastoreService.originalCompanyId).then((res) => {
				// this.basketService.deleteAllBaskets(this.selectedLocation).then(async (data) => {
				//   this.basketService.currentBasket = await this.basketService.createBasket(this.selectedLocation);
				//   console.log('Basket created', this.basketService.currentBasket);
				// }).catch((err) => {
				// this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'));
				// });
				console.log(res);
			});
		}
	}

	// print confirmation page
	print() {
		window.print();
	}

	// Start at the top of the page
	scrollToTop() {
		const scrollToOptions = { top: 0, left: 0, behavior: 'instant' };
		window.scrollTo(scrollToOptions as unknown as ScrollToOptions);
	}
}
